import { render, staticRenderFns } from "./AssetDocuments.vue?vue&type=template&id=83be311a&scoped=true"
import script from "./AssetDocuments.vue?vue&type=script&lang=js"
export * from "./AssetDocuments.vue?vue&type=script&lang=js"
import style0 from "./AssetDocuments.vue?vue&type=style&index=0&id=83be311a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83be311a",
  null
  
)

export default component.exports